import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d8d68c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Selected Target Account", -1))
const _hoisted_4 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_5 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}
const _hoisted_12 = { class: "fw-semibold text-gray-900" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "typeBadge"
}
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = { class: "row mb-9 mt-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bold" }, "Search Rebate Schema ", -1))
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "row mb-9" }
const _hoisted_24 = { class: "col-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Schema Name ", -1))
const _hoisted_26 = { class: "col-9" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1))
const _hoisted_28 = { class: "mt-11" }
const _hoisted_29 = { class: "fv-row mb-7" }
const _hoisted_30 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { style: {"width":"80px"} }
const _hoisted_37 = {
  key: 0,
  class: "text-center fs-4",
  style: {"color":"red"}
}
const _hoisted_38 = { class: "mt-13 d-flex flex-row-reverse" }

import { ref, onMounted } from "vue";
import { Field } from "vee-validate";
// import AccountService from "../../services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import RebateService from "../../../rebate/services/RebateService";
import { RebateDistributionTypes } from "@/core/types/RebateDistributionTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'DirectRebateForm',
  props: {
    rebateType: {},
    accountDetails: {},
    fromRebateRuleDetailId: {},
    targetAccount: {},
    needConfirm: {}
  },
  emits: ["refresh", "clearSearchResult", "changeTargetAccountFn", "updateRebateRuleDetailId"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const { t } = useI18n();
const formTab = ref("rate");
const isLoading = ref(true);
const schemaLoading = ref(true);
const showErrorMsg = ref(false);
const isViewDetail = ref(false);
const targetAccount = ref<any>({});
const selectRebateSchema = ref<any>({});

const rebateSchemaInfo = ref<any>({
  loading: false,
  id: "",
});

const formData = ref({
  sourceAccountUid: props.accountDetails.uid,
  targetAccountUid: props.targetAccount?.uid,
});

const resetRebateForm = () => {
  emits("clearSearchResult");
  formData.value.targetAccountUid = "";
};

const createUpdateDirectRule = async (_op: string) => {
  formData.value["rebateRuleId"] = parseInt(rebateSchemaInfo.value.id);

  try {
    if (_op == "create") {
      await RebateService.postRebateDirectRule(formData.value);
    } else if (_op == "update") {
      await RebateService.putRebateDirectRule(props.fromRebateRuleDetailId, {
        rebateRuleId: formData.value.rebateRuleId,
      });
    }

    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      emits("clearSearchResult");
      emits("refresh");
      resetRebateForm();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const setUpForm = async () => {
  if (rebateSchemaInfo.value.id.length == 0) {
    rebateSchemaInfo.value.id = "";
    return;
  }

  schemaLoading.value = true;

  try {
    const resSymbolList = await RebateService.getSymbolsList();

    selectRebateSchema.value = resSymbolList.reduce((acc, item) => {
      const category = item.category;

      if (!acc[category]) {
        acc[category] = {};
      }

      acc[category][item.code] = {
        symbolCode: item.code,
        rate: 0,
        pips: 0,
        commission: 0,
      };

      return acc;
    }, {});

    const categoryMap = {};
    for (const item of resSymbolList) {
      categoryMap[item.code] = item.category;
    }

    const resSchema = await RebateService.getRebateSchema(
      parseInt(rebateSchemaInfo.value.id)
    );

    rebateSchemaInfo.value.name = resSchema.name;
    rebateSchemaInfo.value.note = resSchema.note;

    resSchema.rebateDirectSchemaItems.forEach(function (item) {
      console.log(item.symbolCode);
      if (
        selectRebateSchema.value[categoryMap[item.symbolCode]] !== undefined
      ) {
        selectRebateSchema.value[categoryMap[item.symbolCode]][
          item.symbolCode
        ] = {
          symbolCode: item.symbolCode,
          rate: item.rate,
          pips: item.pips,
          commission: item.commission,
        };
      }
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
  schemaLoading.value = false;
};

const remoteMethod = async (query: string) => {
  if (query) {
    rebateSchemaInfo.value.loading = true;

    const options = await RebateService.getRebateSchemaList({
      keyword: query,
    });

    rebateSchemaInfo.value["options"] = options.data;
    rebateSchemaInfo.value.loading = false;
  } else {
    rebateSchemaInfo.value["options"] = [];
  }
};

const viewDetail = async (_id: any) => {
  try {
    const res = await RebateService.getRebateDirectRuleById(_id);
    rebateSchemaInfo.value.id = [res.rebateDirectSchemaId];

    setUpForm();
  } catch (error) {
    MsgPrompt.error(error);
  }
};

onMounted(async () => {
  if (
    props.fromRebateRuleDetailId != -1 &&
    props.fromRebateRuleDetailId != null
  ) {
    isViewDetail.value = true;
    viewDetail(props.fromRebateRuleDetailId);
  }
  targetAccount.value = props.targetAccount;
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_IbSalesInfo = _resolveComponent("IbSalesInfo")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingRing)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (props.rebateType == _unref(RebateDistributionTypes).Direct)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_5, [
                    _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("fields.user")), 1),
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.role")), 1),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.group")), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.type")), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.ib")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.salesWithCode")), 1),
                    (!isViewDetail.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_ctx.$t("action.action")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_12, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_UserInfo, {
                        url: "#",
                        user: targetAccount.value.user,
                        class: "me-2"
                      }, null, 8, ["user"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.accountRole." + targetAccount.value.role)), 1),
                    _createElementVNode("td", null, _toDisplayString(targetAccount.value.group), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.account." + targetAccount.value.type)), 1),
                    _createElementVNode("td", null, [
                      (targetAccount.value.role == 400)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(targetAccount.value.tradeAccount.accountNumber), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "UID: " + _toDisplayString(targetAccount.value.uid), 1))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_IbSalesInfo, {
                        url: "#",
                        user: targetAccount.value.agentAccount.user,
                        uid: targetAccount.value.agentAccount.uid,
                        class: "me-2"
                      }, null, 8, ["user", "uid"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_IbSalesInfo, {
                        url: "#",
                        user: targetAccount.value.salesAccount.user,
                        code: targetAccount.value.salesAccount.code,
                        uid: targetAccount.value.salesAccount.uid,
                        class: "me-2"
                      }, null, 8, ["user", "code", "uid"])
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      (!isViewDetail.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-light btn-success btn-sm me-3",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('changeTargetAccountFn')))
                          }, _toDisplayString(_ctx.$t("action.change")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_select, {
                modelValue: rebateSchemaInfo.value.id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rebateSchemaInfo.value.id) = $event)),
                clearable: "",
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                placeholder: "Please enter a keyword",
                "remote-method": remoteMethod,
                loading: rebateSchemaInfo.value.loading,
                onChange: setUpForm
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateSchemaInfo.value.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.key,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "loading"])
            ]),
            (isViewDetail.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-light btn-success btn-sm ms-5",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (createUpdateDirectRule('update')))
                }, " Update Rebate Schema "))
              : _createCommentVNode("", true)
          ])
        ]),
        (rebateSchemaInfo.value.id != '' && schemaLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_LoadingRing)
            ]))
          : _createCommentVNode("", true),
        (rebateSchemaInfo.value.id != '' && !schemaLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_unref(Field), {
                    modelValue: rebateSchemaInfo.value.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rebateSchemaInfo.value.name) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: rebateSchemaInfo.value.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rebateSchemaInfo.value.name) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_unref(Field), {
                    modelValue: rebateSchemaInfo.value.note,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((rebateSchemaInfo.value.note) = $event)),
                    class: "form-control form-control-lg form-control-solid",
                    type: "number",
                    name: "symbolRule",
                    autocomplete: "off"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: rebateSchemaInfo.value.note,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rebateSchemaInfo.value.note) = $event)),
                        size: "large"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("ul", _hoisted_30, [
                    _createElementVNode("li", _hoisted_31, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'rate' }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (formTab.value = 'rate'))
                      }, "Rate", 2)
                    ]),
                    _createElementVNode("li", _hoisted_32, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'pips' }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (formTab.value = 'pips'))
                      }, "Pips", 2)
                    ]),
                    _createElementVNode("li", _hoisted_33, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: formTab.value === 'commission' }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (formTab.value = 'commission'))
                      }, "Commission", 2)
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectRebateSchema.value, (symbols, category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category,
                    style: {"box-shadow":"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"},
                    class: "mb-7 p-7"
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h3", null, _toDisplayString(category), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(symbols, (rule, symbol) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-4 mt-5",
                          key: symbol
                        }, [
                          _createVNode(_unref(Field), {
                            modelValue: selectRebateSchema.value[category][symbol][formTab.value],
                            "onUpdate:modelValue": ($event: any) => ((selectRebateSchema.value[category][symbol][formTab.value]) = $event),
                            class: "form-control form-control-lg form-control-solid",
                            type: "number",
                            name: "symbolRule",
                            autocomplete: "off"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: selectRebateSchema.value[category][symbol][formTab.value],
                                "onUpdate:modelValue": ($event: any) => ((selectRebateSchema.value[category][symbol][formTab.value]) = $event),
                                size: "large"
                              }, {
                                prepend: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("label", null, _toDisplayString(symbol), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                (showErrorMsg.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Please input target account number. "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "btn btn-light btn-danger btn-lg me-3 mb-9",
                    onClick: resetRebateForm
                  }, " Cancel "),
                  (!isViewDetail.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-light btn-success btn-lg me-3 mb-9",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (createUpdateDirectRule('create')))
                      }, " Apply to Client "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})